shopDataLayer = {
	header: {
		// search: {
		// 	placeholder: 'Hledat produkt',
		// 	buttonText: 'Hledej',
		// },
		// contact: {
		// 	call: {
		// 		image: '',
		// 		title: '',
		// 		number: '',
		// 	},
		// 	write: {
		// 		image: '',
		// 		title: '',
		// 		mail: '',
		// 	},
		// },
	},
	footer: {
		// newsletter: {
		// 	title: '',
		// 	subtitle: '',
		// 	placeholder: '',
		// 	buttonText: '',
		// },
		// navigation: {
		// 	more: 'Zobrazit další stránky',
		// },
		// categories: {
		// 	more: 'Zobrazit další kategorie',
		// },
		// signature: "Vytvořili <a href='https://www.webotvurci.cz/' target='_blank'>Webotvůrci</a> na platformě <a href='https://www.shoptetpremium.cz/' target='_blank'>Shoptet Premium</a>",
	},
	productDetail: {
		// parametersTop: [],
		// availabilityLabel: '',
		// buttonText: 'Koupit',
		// emptyDescription: '',
		// parametersTitle: '',
		// descriptionTitle: '',
		// hiddenParameters: [],
	},
	checkout: {
		participant: {
			title: "Účastník",
			separator: "___________________________",
			fields: [
				{
					id: "name",
					type: "textarea",
					label: "Jméno dítěte, alergie, užívané léky nebo další sdělení",
					required: true,
					noteFormat: "{value}",
				},
				{
					id: "birthDate",
					type: "date",
					label: "Datum narození dítěte",
					required: true,
					noteFormat: "Datum narození: {value}",
				},
				{
					id: "transport",
					type: "select",
					label: "Doprava ZDARMA",
					tooltip: "Na první turnus zajišťujeme pouze odvoz a poslední pouze dovoz.",
					required: true,
					placeholder: "Vyberte možnost",
					options: ["Brno", "Prostějov", "Olomouc", "Pardubice", "Hr. Králové", "Praha", "Ostrava", "Dopravu nechci"],
					noteFormat: "Doprava zdarma: {value}",
				},
				{
					id: "tshirt",
					type: "select",
					label: "Tričko ZDARMA",
					required: true,
					placeholder: "Vyberte velikost",
					options: ["110 cm / 3 roky", "122 cm / 6 let", "134 cm / 8 let", "146 cm / 10 let", "158 cm / 12 let", "S", "M", "L"],
					noteFormat: "Tričko zdarma: {value}",
				},
			],
		},
	},
};
